export default __webpack_public_path__ + "static/media/woman-mountain-biking_1f6b5-200d-2640-fe0f.17b591ba.png";